import { useParamsDialog } from "@/hooks"

import {
  communicationInfoDialog,
  disclaimerInfoDialog,
  profilingInfoDialog,
  termsAndConditionFormInfoDialog,
} from "../config/consts"

type InfoDialogWithPDFType =
  | typeof communicationInfoDialog
  | typeof profilingInfoDialog
  | typeof disclaimerInfoDialog
  | typeof termsAndConditionFormInfoDialog

const useInfoDialogWithPDF = (type: InfoDialogWithPDFType) =>
  useParamsDialog(type)

export { useInfoDialogWithPDF }
export type { InfoDialogWithPDFType }
